'use client';

import Link from 'next/link';
import { SquareArrowOutUpRight } from 'lucide-react';
import { NAV_LINKS } from './constants';

export function NavLinks() {
  return (
    <nav className="text-[#124673] font-medium">
      <ul className="flex items-center gap-8">
        {NAV_LINKS.map((link) => (
          <li key={link.label}>
            <Link
              href={link.href}
              prefetch={false}
              aria-label={link.label}
              title={link.label}
              className="flex items-center gap-1 font-semibold"
              target={link.external ? '_blank' : '_self'}
              rel={link.external ? 'noopener noreferrer' : undefined}
            >
              <span className="hidden md:inline">{link.label}</span>
              {link.external && <SquareArrowOutUpRight size={18} aria-hidden />}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
